import { ClienteFilter } from '../../../../pessoa/cliente/filter/cliente-filter';
import { campanhaClienteVisualizacaoModoAmbos } from '../visualizacao-modo';

export class CampanhaClienteFilter extends ClienteFilter {
    visualizacaoModo: number;

    constructor() {
        super();
        this.setDefaults();
    }

    private setDefaults() {
        this.visualizacaoModo = campanhaClienteVisualizacaoModoAmbos.id;
    }

    clear() {
        super.clear();
        this.setDefaults();
    }
}
